import { CssEntry } from './contentfulAttributes'
import { MixpanelTracking } from './mixpanel'

export interface MediaInsert {
  contentful_id: string
  __typename: 'ContentfulMediaInsert'
  createdAt: string
  name: string
  assetUrl: string
  assetFile: AssetSource
  loop: boolean
  autoPlay: boolean
  thumbnail: ThumbnailSource
  variant: MediaInsertVariants
  transcript: Transcript | null
  buttonText: string
  schemaName: string
  schemaDescription: string
  buttonVariant?: 'contained' | 'outlined'
  codeClasses: string[] | null
  css: CssEntry[] | null
  mixpanelTracking: MixpanelTracking | null
}

export interface AssetSource {
  contentful_id: string
  title: string
  description: string
  file: File
  internal: Internal
}

export interface ThumbnailSource {
  file: File
}

export interface File {
  url: string
}

export interface Internal {
  contentDigest: string
}

export interface Transcript {
  transcript: string
}

export enum MediaInsertVariants {
  ClickToPlay = 'Click to Play Button',
}

export interface MediaSchema {
  name: string | null
  description: string | null
  thumbnailUrl: string | null
  uploadDate: string | null
  contentUrl: string | null
  transcript: string | null
}
